const scrollSnaps = {
    none: '',
    x: 'snapX',
    y: 'snapY',
}

const scrollSnapDefault = scrollSnaps.none;

const scrollbarApperance = {
    visible: 'visible',
    hidden: 'hidden',
    default: '',
}

const scrollbarApperanceDefault = scrollbarApperance.default;

export {
    scrollSnaps,
    scrollSnapDefault,
    scrollbarApperance,
    scrollbarApperanceDefault,
}